// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";

// TODO: Replace the following with your app's Firebase project configuration
// For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB0OCpidhxEEzMHn0LsHrOQnEprb027QRY",
    authDomain: "bcd-indoor-active-d.firebaseapp.com",
    databaseURL: "https://bcd-indoor-active-d.firebaseio.com",
    projectId: "bcd-indoor-active-d",
    storageBucket: "bcd-indoor-active-d.appspot.com",
    messagingSenderId: "392848607344",
    appId: "1:392848607344:web:be415e47cdb611ac234cb5",
    measurementId: "G-JGZYGMY2YB"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;